import React, {useState, useEffect} from 'react';
import {Tooltip} from "primereact/tooltip";
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {BlockUI} from "primereact/blockui";
import axios from "axios"; import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";

const _FM_OoobertFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [berth, setBerth] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "out-of-order-berth/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({});
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderOooberthList: Math.random(),
            rerenderReservationList: Math.random(),
            selectedOoobertId: response.data.data.id
          })
          if (props.closeForm === true) {
            if(window.location.href.includes('#/calendar')) {
              navigate(-2)
            } else {
              navigate(-1)
            }
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "out-of-order-berth",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderOooberthList: Math.random(),
            rerenderReservationList: Math.random(),
            selectedOoobertId: response.data.data.id
          })
          if (props.closeForm === true) {
            if(window.location.href.includes('#/calendar')) {
              navigate(-2)
            } else {
              navigate(-1)
            }
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "berth",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setBerth(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setLoading(false)
      })
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "out-of-order-berth/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  useEffect(() => {
    if (formData && formData.berth && formData.berth.id) {
      setFormData({
        ...formData,
        berth: formData.berth.id
      })
    }
    if (window.App.state && window.App.state.propsReservation && window.App.state.propsReservation.date) {
      let formattedFromDate = moment.utc(window.App.state.propsReservation.date).local().format(t('YYYY-MM-DD'));
      setFormData({
        ...formData,
        start_at: formattedFromDate,
      })
    }
  }, [formData.berth])

  useEffect(() => {
    setFormData({
      ...formData,
      berth: window.App.state.selectedBerthId
    })
  }, [window.App.state.selectedBerthId])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('oooberth_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="note" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"note"}/>
                      <label htmlFor="note"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('note')}</label>
                      <span className="p-d-block">
                      <InputText id="note" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     note: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     note: e.target.value
                                   })
                                 }}
                                 value={formData.note}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <Field name="berth" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"berth"}/>
                      <label htmlFor="berth"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('berth')}</label>
                      <span className="">
                      <Dropdown  options={berth}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                id={"berth"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    berth: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    berth: e.value
                                  })
                                }}
                                value={formData.berth}
                                showClear
                      />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6"} style={{minWidth: '160px'}}>
                  <Field name="start_at" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"start_at"}/>
                      <label htmlFor="start_at"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('start_at')}</label>
                      <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"start_at"}
                                       mask={t('9999-99-99')}
                                       placeholder={t('YYYY-MM-DD_placeholder')}
                                       value={formData.start_at}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             start_at: e.value
                                           })
                                           setNewFormData({
                                             ...newFormData,
                                             start_at: e.value
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.start_at ? moment(formData.start_at, 'YYYY-MM-DD').toDate() : null}
                                      locale="default"
                                      dateFormat={t('YY-MM-DD')}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          start_at: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          start_at: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                        </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6"} style={{minWidth: '160px'}}>
                  <Field name="end_at" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"end_at"}/>
                      <label htmlFor="end_at"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('end_at')}</label>
                      <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"end_at"}
                                       mask={t('9999-99-99')}
                                       placeholder={t('YYYY-MM-DD_placeholder')}
                                       value={formData.end_at}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             end_at: e.value
                                           })
                                           setNewFormData({
                                             ...newFormData,
                                             end_at: e.value
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.end_at ? moment(formData.end_at, 'YYYY-MM-DD').toDate() : null}
                                      locale="default"
                                      dateFormat={t('YY-MM-DD')}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          end_at: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          end_at: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                        </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {formData.id && formData.accommodation && formData.accommodation.name &&
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="accommodation" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <HelpComponent type={"field"} field={"status"}/>
                        <label htmlFor="status"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('accommodation')}</label>
                        <span className="p-d-block fake-input">
                          <span className={"p-text-nowrap"}>{formData?.accommodation?.name}<span className={"tt-auto-invoice p-ml-2"} data-pr-tooltip={formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? t('auto_invoice_tooltip_active') : t('auto_invoice_tooltip_inactive')}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={"auto-invoice-icon"} style={{ color: formData?.accommodation?.auto_invoice_on_check_out === 'CREATE_AND_SYNC' ? '#0abb87' : '#dddddd', position: 'relative', bottom: '-3px' }}><path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8" /><path d="M5 21l2.5-1.5L10 21l2.5-1.5L14 21l1.5-1" /><path d="M9 7h6" /><path d="M9 11h4" /><path d="M18 14a3 3 0 1 0 3 3" /><path d="M21 20v-3h-3" /></svg></span><Tooltip target=".tt-auto-invoice"/></span>
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
      <div className={"p-mt-2"}>
        <i className={"pi pi-exclamation-circle"}></i>
        &nbsp;
        {t('form_under_edit')}
        {formData && formData.under_edit_by_name_snap &&
        <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
        }
      </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_OoobertFormComponent);
